import { render, staticRenderFns } from "./InquiryReclass.vue?vue&type=template&id=2e0e8c48&"
import script from "./InquiryReclass.vue?vue&type=script&lang=ts&"
export * from "./InquiryReclass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0e8c48')) {
      api.createRecord('2e0e8c48', component.options)
    } else {
      api.reload('2e0e8c48', component.options)
    }
    module.hot.accept("./InquiryReclass.vue?vue&type=template&id=2e0e8c48&", function () {
      api.rerender('2e0e8c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Inquiry/InquiryReclass.vue"
export default component.exports